import { ComboboxAndPopover } from '@/components/ui/combobox/combobox-and-popover';
import HotKeyListener from '@/components/ux/hot-key-listener';
import { HOTKEYS } from '@/lib/hotkeys';
import type { Deal } from '@/models/registry';
import { type DeliveryStage } from '@/models/types.ts';
import { useRef, useState } from 'react';
import { DeliveryStageBadge } from './delivery-stage-badge';
import { DeliveryStageCombobox } from './delivery-stage-combobox';

export function DeliveryStageSelector({
  id,
  shortId,
  dealStatus,
  value,
  hideCopy = false,
  side = 'right',
  withHotkeyListener = false,
  badgeClassName,
}: {
  id: Deal['id'];
  shortId: Deal['short_id'];
  dealStatus: Deal['status'];
  value?: DeliveryStage;
  hideCopy?: boolean;
  side?: 'left' | 'right' | 'bottom' | 'top';
  withHotkeyListener?: boolean;
  badgeClassName?: string;
}) {
  const [open, setOpen] = useState(false);
  const statusButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div>
      <ComboboxAndPopover
        combobox={
          <DeliveryStageCombobox
            id={id}
            shortId={shortId}
            dealStatus={dealStatus}
            value={value}
            afterOnChange={() => {
              setOpen(false);
            }}
          />
        }
        side={side}
        align="start"
        open={open}
        setOpen={setOpen}
      >
        <div>
          <DeliveryStageBadge
            value={value}
            hideCopy={hideCopy}
            buttonRef={statusButtonRef}
            className={badgeClassName}
          />
        </div>
      </ComboboxAndPopover>

      {withHotkeyListener && (
        <HotKeyListener
          hotkeys={HOTKEYS.DEAL_DELIVERY_STAGE}
          onHotkeyPressed={() => {
            statusButtonRef.current?.click();
          }}
        />
      )}
    </div>
  );
}
